import { proNavigator } from "single-spa/react-app/ProNavigator";
import { DefaultFetchService } from "app/services/fetchService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { isIncludeSubDomains } from "app/UtilitiesAndConstants/UtilityFunctions/common";

import type { NewVsReturning } from "./types";

const getNewVsReturningQueryParams = () => {
    const apiParams = proNavigator.getApiParams();
    const { key: keys, from, to, isWindow, country } = apiParams;
    const { isWWW } = proNavigator.getParams();
    const includeSubDomains = isIncludeSubDomains(isWWW);
    const webSource = devicesTypes.TOTAL;
    return {
        includeSubDomains,
        keys,
        from,
        to,
        country,
        webSource,
        isWindow,
    };
};

export const getNewVsReturning = (): Promise<NewVsReturning> => {
    const fetchService = DefaultFetchService.getInstance();
    const queryParams = getNewVsReturningQueryParams();
    const ENDPOINT = "widgetApi/WebNewVsReturning/NewVsReturning/Data";
    return fetchService.get<NewVsReturning>(ENDPOINT, queryParams);
};
